"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { IconGlyphicon } from 'generics/icons';
import { BootButton } from 'generics/buttons';
import { MarketSearch } from 'api/ordersAPICall';
import { refreshBlockedPairs, blockedPairsSource } from 'api/rpcAPICall';
import { loadCurrentApp, storeCurrentApp } from  'generics/routed.js';

import { SimplePagerView } from 'components/generics';
import ApplicationEvents from 'components/applicationEvents';
import { ViewAppIdIcon } from 'components/commonAssets';
import { ViewMarketAppFilterEditor } from 'components/marketAppFilterEditor';
import { ViewMarketSortOrder } from 'components/marketSortSelector';
import MoneyUtil from 'components/moneyUtil';
import { _I_, defineSimpleTerm } from 'components/locs';


// LogStream.enable( "VIEWMARKETEDITEMSLIST" );

const ViewMarketedItemPrice = ({ item })  =>  {
    const curr = SettingsInjections.getUsedCurrency().market;
    const price = MoneyUtil.preferMoney(item.price, null, curr, curr);
    const havePrice = !!( (price > 0) && (item.depth > 0) );

    if (havePrice)  {
      return (<div  className="item-price"
                    title={_I_(`ViewMarketedItem.SellingFrom`)}>
              {MoneyUtil.formatMoney(price, curr)}
          </div>);
    }

    return (<div   className="item-soldout"
                   title={_I_(`ViewMarketedItem.SoldOutTip`)}>
          {_I_(`ViewMarketedItem.SoldOutText`)}
        </div>);
}


// { "appid", "hash_name", "name", "icon", "color" }
const ViewMarketedItem = ({ item, handler })  =>  {
    const iconStyle = item.color ? {"borderColor":"#"+item.color} : {};
    const nameStyle = item.color ? {"color":"#"+item.color} : {};

    return (
      <div className="view-marketed-backdrop">
        <div className="view-marketed-item" onClick={handler}>
          <img  className="item-icon" key={item.icon} src={item.icon}  style={iconStyle}  />
          <div className="item-desc">
            <div>
              <div  className="item-name"  style={nameStyle}  >
                {item.name}
              </div>
              <ViewMarketedItemPrice item={item} />
            </div>
            <div>
              <div> </div>
              <ViewAppIdIcon appId={item.appid} compact />
            </div>
          </div>
        </div>
      </div>);
};


// { "appid", "hash_name", "name", "icon", "color" }
class ViewMarketedItemsList extends React.Component  {

  selectItem( item )  {
    ApplicationEvents.emit_async( "market.setCurrentAssetByHash", item.appid, item.hash_name );
  }


  render()  {
    const indexShift = this.props.indexShift;

    const items = this.props.items.slice(0, this.props.pagesize);
    if ( items.length == 0 )  {
      return (
        <div  className="ViewMarketedItemsList">
          <div className="text-center">
            <div><h1 className="glyphicon glyphicon-question-sign" /></div>
            <div>{_I_("ViewItemSearch.stub.empty")}</div>
          </div>
       </div>);
    }


    return (
      <div  className="ViewMarketedItemsList">
        {
          items.map( ( item, key ) =>  (<ViewMarketedItem
                                                key={`i_${indexShift}_${key}`}
                                                handler={() => this.selectItem( item )}
                                                item={item}
                                              />)  )
        }
      </div>);
  }
};


export class ViewItemSearch extends React.Component  {
  constructor( props )  {
    super( props );
    this.state = {
      "foundItems":[],
      "skip":0,
      "words":"[]",
      "selectedApp": null,
      "selectedTagsMap":{},
      "sortOrder":""
    };

    this.PAGESIZE = 10;
  }


  searchItems ()  {
    const words = JSON.parse( this.state.words );
    const apps = [this.state.selectedApp].filter( (it) => +it>0 );
    const tags = this.state.selectedTagsMap;
    const fetchCount = this.PAGESIZE+1; // Fetch one element more to decide if we have next page

    MarketSearch(
        words, apps, tags,
        this.state.skip, fetchCount,
        this.state.sortOrder

      ).then( ( assets ) =>  {
        LogStream("VIEWMARKETEDITEMSLIST").info( "searchItems -> ", assets );
        this.setState( {"foundItems": assets} );
        return assets;

      }).catch( ( reason ) =>  {
        this.setState( {"foundItems": []} );

        reason = Object.assign( {}, reason,
                                {
                                  "caption":"Search Item Error",
                                  "message": ("Failed to search market for items:\n"+
                                              reason.message)
                                });

        LogStream("VIEWMARKETEDITEMSLIST").error( "searchItems - Failed (", reason, ")" );
        ApplicationEvents.emit_async( "EventLog.append", reason );
    });
  }


  canGoForward()  {
    return this.state.foundItems.length > this.PAGESIZE;
  }


  canGoBackward()  {
    return this.state.skip > 0;
  }


  onPageForward ()  {
    if ( !this.canGoForward() )
      return;

    this.setState( {"skip": this.state.skip + this.PAGESIZE } )
  }


  onPageBackward ()  {
    if ( !this.canGoBackward() )
      return;

    let skip = this.state.skip - this.PAGESIZE;
    if ( skip <= 0 )
      skip = 0;
    this.setState( {"skip": skip } );
  }


  onNewSearch ()  {
    const words = this.searchInput.value.split(/\s/).filter( (w) => !!w );
    const wordsStr = JSON.stringify(words);
    if ( wordsStr == this.state.words )
      return; // no updates

    this.setState({ "skip":0, "words":wordsStr });
  }

  onPressKey (e)  {
    if (e.keyCode == 13)
      this.onNewSearch();
  }

  componentDidMount()  {
    const appIds = (this.props.appIds||[]).map( it => +it ).filter( it => it>0 );
    const lruAppId = +(loadCurrentApp());
    const currentAppId = ( appIds.length == 1 )  ?  appIds[0]  :  lruAppId;

    if ( (currentAppId > 0) && (appIds.indexOf(currentAppId) >= 0) )  {
      this.toggleAppFilter(currentAppId, null);
      return;
    }

    this.searchItems();
  }

  componentWillReceiveProps(nextProps)  {
    // this.searchItems();
  }

  componentDidUpdate(prevProps, prevState)  {
    if (
         ( prevState.skip   != this.state.skip    ) ||
         ( prevState.words  != this.state.words   ) ||
         ( prevState.selectedApp  != this.state.selectedApp  ) ||
         ( prevState.sortOrder  != this.state.sortOrder  ) ||
         ( prevState.selectedTagsMap  != this.state.selectedTagsMap  )
       )  {

      this.searchItems ();

    }

  }


  toggleAppFilter( selectedApp, selectedTagsMap )  {
    selectedTagsMap  =  selectedTagsMap || [];

    if ( selectedApp == this.state.selectedApp )  {
      const strTags = Object.keys(selectedTagsMap).sort().join("\0");
      const strStateTags = Object.keys(this.state.selectedTagsMap).sort().join("\0");
      if ( strTags == strStateTags )  {
        return; // no updates
      }
    }

    storeCurrentApp(selectedApp);
    this.setState({  "skip":0, selectedApp, selectedTagsMap  });
  }


  toggleSortOrder( sortOrder )  {
    if ( sortOrder == this.state.sortOrder )  {
      return; // no updates
    }

    this.setState({  "skip":0, sortOrder  })
  }


  renderWordsTerms()  {
    const words = (JSON.parse( this.state.words ) || []).join(" ");
    if ( words.length )  {
      return [
          <BootButton  key="words"  variant="default"
              mixClasses="view-marketed-search-term-button"
              onClick={()  =>  {this.searchInput.value = ""; this.onNewSearch(); } }
            >
            <IconGlyphicon type="filter" />
            <span className="caption">&nbsp;{words}&nbsp;</span>
            <IconGlyphicon type="remove" />
          </BootButton>
        ];
    }

    return [];
  }


  renderAppTerms( )  {
    if ( this.state.selectedApp )  {
      return [
          <BootButton  key="app"  variant="default"
                mixClasses="view-marketed-search-term-button"
                onClick={()  => this.toggleAppFilter( null, null )}
              >
            <ViewAppIdIcon appId={this.state.selectedApp} compact>
              &nbsp;<IconGlyphicon type="remove" />&nbsp;
            </ViewAppIdIcon>
          </BootButton>
        ];
    }

    return [];
  }


  renderTagsTerms( )  {
    const {selectedApp, selectedTagsMap} = this.state;

    if ( !selectedApp )
      return [];

    const tags = Object.values( selectedTagsMap );
    if ( !tags.length )
      return [];

    const tagmap = {};
    tags.map(  ({ loc, name, color }) =>  {
      const [ ,category, tagname ] = (/^([^:]+)(:.*)?$/ig).exec( name );
      if ( !tagname )
        return;

      if ( !tagmap[category] )  {
        tagmap[category] = { name: category, loc:"", rtags:[] };
      }

      tagmap[category].rtags.push({ loc, name, color });
    });


    return Object.values( tagmap ).map( ({ name, loc, rtags}) =>  {
        const newTags = Object.assign( {}, selectedTagsMap );

        const items = rtags.map( ({ loc, name, color }, idx) => {
          delete newTags[name];
          return (<span className="subcap" key={`t${name}`}>{loc}</span>);
        });

        const onClick = () =>  this.toggleAppFilter( selectedApp, newTags );

        return (<BootButton  key={`tag_${name}`}  variant="default"
                        mixClasses="view-marketed-search-term-button"
                        onClick={onClick}
                      >
                      {loc}&nbsp;
                      <IconGlyphicon type="filter" />
                      <span className="caption">&nbsp;{items}&nbsp;</span>
                      <IconGlyphicon type="remove" />
                  </BootButton>)

    });
  }


  renderCurrentSearchTerms( )  {
    const terms = [
      ...this.renderWordsTerms(),
      ...this.renderAppTerms(),
      ...this.renderTagsTerms()
    ];

    const heading = _I_(
        (terms.length == 0) ?
            "ViewItemSearch.heading.showAll" :
            "ViewItemSearch.heading.resultsFor"
      );

    return (
        <div className="well well-sm ViewItemSearchTerms">
          <b className="view-marketed-search-heading">{  heading  }</b>
          {  terms  }
        </div>
      );
  }


  renderSearchPanel()  {
    return (
        <div className="ViewItemSearchPanel">
          <ViewMarketSortOrder  sortOrder={this.state.sortOrder}
                                onChange={(o) => this.toggleSortOrder(o)} />
          <div  className="view-marketed-search-label">
            {_I_("ViewItemSearch.label.search")}
          </div>
          <div  className="view-marketed-search-input-holder">
            <input
                type="text"
                className="form-control input-sm"
                placeholder={_I_("ViewItemSearch.termsPlaceholder")}
                ref={ (searchInput) => {this.searchInput = searchInput;} }
                onKeyUp={ this.onPressKey.bind(this) }
              />
            <div  className="view-marketed-search-search"
                  onClick={ () =>  { this.onNewSearch(); } }
                >
              <IconGlyphicon type="search" />
            </div>
          </div>

          <ViewMarketAppFilterEditor
                  selectedApp={this.state.selectedApp}
                  selectedTagsMap={this.state.selectedTagsMap}
                  appIds={this.props.appIds}
                  onUpdate={( appId, tags ) => this.toggleAppFilter( appId, tags )}
                />

        </div>
      );
  }


  render()  {
    return (
      <div className="ViewItemSearch">
        {  this.renderCurrentSearchTerms()  }
        <div className="MainBlock">
          <div className="ResultsSection">
            <ViewMarketedItemsList
                                  items={this.state.foundItems}
                                  indexShift={this.state.skip}
                                  pagesize={this.PAGESIZE}
                                />

            <SimplePagerView
                disableBack={!this.canGoBackward()}
                disableForward={!this.canGoForward()}
                onClickBack={ () =>  { this.onPageBackward(); } }
                onClickForward={ () =>  { this.onPageForward(); } }
                currentPosition={1+Math.floor(this.state.skip/this.PAGESIZE)}
                arrowsWithIndexes
                />
          </div>
          {  this.renderSearchPanel()  }
        </div>
      </div>);
  }
}


defineSimpleTerm( "ViewMarketedItem.SoldOutText",  "sold out",       {
  "ru_RU": "распродано",
  "cs_CZ": "sold out",
  "fr_FR": "épuisé",
  "de_DE": "ausverkauft",
  "it_IT": "terminato",
  "ko_KR": "재고 없음",
  "pl_PL": "wyprzedane",
  "pt_PT": "sold out",
  "es_ES": "agotado",
  "zh_CN": "售完",
  "zh_TW": "售完"
} );


defineSimpleTerm( "ViewMarketedItem.SoldOutTip",  "No sell orders",       {
  "ru_RU": "Нет предложений на продажу",
  "cs_CZ": "No sell orders",
  "fr_FR": "Pas d'ordre de vente",
  "de_DE": "Keine Verkaufsaufträge",
  "it_IT": "Nessun ordine di vendita",
  "ko_KR": "판매 주문 없음",
  "pl_PL": "Brak poleceń kupna",
  "pt_PT": "No sell orders",
  "es_ES": "No hay órdenes de venta",
  "zh_CN": "没有出售订单",
  "zh_TW": "沒有出售訂單"
} );


defineSimpleTerm( "ViewMarketedItem.SellingFrom",  "Selling from...",       {
  "ru_RU": "Предлагается от...",
  "cs_CZ": "Selling from...",
  "fr_FR": "Vendre à partir de ...",
  "de_DE": "Verkauf durch...",
  "it_IT": "In vendita dal...",
  "ko_KR": "다음으로부터 판매됨",
  "pl_PL": "Sprzedawane od...",
  "pt_PT": "Selling from...",
  "es_ES": "Vendiendo desde...",
  "zh_CN": "销售来源…",
  "zh_TW": "銷售來源..."
} );


defineSimpleTerm( "ViewItemSearch.heading.showAll",  "Showing all listings",       {
  "ru_RU": "Все позиции",
  "cs_CZ": "Showing all listings",
  "fr_FR": "Afficher toutes les annonces",
  "de_DE": "Alle Listen anzeigen",
  "it_IT": "Mostra tutte le liste",
  "ko_KR": "아이템 목록",
  "pl_PL": "Wyświetlane wszystkie oferty",
  "pt_PT": "Showing all listings",
  "es_ES": "Mostrando todos los listados",
  "zh_CN": "显示所有列表",
  "zh_TW": "顯示所有列表"
} );


defineSimpleTerm( "ViewItemSearch.heading.resultsFor",  "Showing results for:",       {
  "ru_RU": "Результаты для:",
  "cs_CZ": "Showing results for:",
  "fr_FR": "Montrer les résultats pour:",
  "de_DE": "Ergebnisse anzeigen:",
  "it_IT": "Mostra risultati per:",
  "ko_KR": "다음 게임의 아이템 리스트:",
  "pl_PL": "Wyświetlane wyniki dla:",
  "pt_PT": "Showing results for:",
  "es_ES": "Se muestran los resultados para:",
  "zh_CN": "显示结果：",
  "zh_TW": "顯示結果："
} );


defineSimpleTerm( "ViewItemSearch.stub.empty",  "Empty search result",       {
  "ru_RU": "Ничего не найдено",
  "cs_CZ": "Empty search result",
  "fr_FR": "Résultat de recherche vide",
  "de_DE": "Leeres Suchergebnis",
  "it_IT": "Svuota risultati ricerca",
  "ko_KR": "검색 결과 비우기",
  "pl_PL": "Pusty wynik wyszukowania",
  "pt_PT": "Empty search result",
  "es_ES": "Resultado de búsqueda vacío",
  "zh_CN": "清空搜索结果",
  "zh_TW": "清空搜索結果"
} );


defineSimpleTerm( "ViewItemSearch.termsPlaceholder",  "Search terms here",       {
  "ru_RU": "Поиск",
  "cs_CZ": "Search terms here",
  "fr_FR": "Termes de recherche ici",
  "de_DE": "Bedingungen hier suchen",
  "it_IT": "Ricerca termine qui",
  "ko_KR": "검색어를 입력하세요",
  "pl_PL": "Tutaj słowa kluczowe",
  "pt_PT": "Search terms here",
  "es_ES": "Buscar términos aquí",
  "zh_CN": "在此处搜索字词",
  "zh_TW": "在此處搜索字詞"
} );


defineSimpleTerm( "ViewItemSearch.label.search",  "Search for items",       {
  "ru_RU": "Поиск",
  "cs_CZ": "Search for items",
  "fr_FR": "Rechercher des items",
  "de_DE": "Nach Items suchen",
  "it_IT": "Ricerca oggetti",
  "ko_KR": "아이템 찾기",
  "pl_PL": "Szukaj przedmiotów",
  "pt_PT": "Search for items",
  "es_ES": "Buscar artículos",
  "zh_CN": "搜索物品",
  "zh_TW": "搜索物品"
} );

